import React, { useContext, useEffect, useState } from "react";
import { selectedSupplierType } from "./AssociateItems";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Label } from "../../../../../../stories/Label/Label";
import { Button } from "../../../../../../stories/Button/Button";

import { AppContext } from "../../../../../../context/context";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  debouncedDelay,
  emptyMessage,
} from "../../../../../../utils/constants";
import { Operation } from "../../../../../../utils/Enum.types";
import {
  getModifiedScrollHeight,
  handleMUISelectEvent,
} from "../../../../../../utils/UtilFunctions";
import MessageModal from "../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../pages/LoadingModal";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import { payloadTypes } from "../../../../../../context/reducer";
import NoData from "../../../../../../images/NoData.svg";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { Checkbox } from "@mui/material";
import { TableHeaderProps } from "../../../../../../utils/types";
import {
  AtsStckItemEdge,
  AtsStckItemOrderField,
  GetItemsResult,
  GetItemsVars,
  ItemQueryType,
  filterDataType,
} from "../../items/queries/types";
import { GetItems } from "../../items/queries/queries";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { useLazyQuery, useMutation } from "@apollo/client";
import { AddItemLdgrAssociByLdgr } from "./queries/mutations";
import {
  AddItemLdgrAssociByLdgrResult,
  AddItemLdgrAssociByLdgrVar,
} from "./queries/types";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { GetSuppliers } from "../../supplier/queries/queries";
import {
  AtsAcLdgrOrderField,
  LdgrQueryType,
} from "../../supplier/queries/types";
import Input from "../../../../../../stories/Input/Input";
import ItemGroupSelect from "../../../../../../customComponents/ItemGroupSelect";
import ItemCategorySelect from "../../../../../../customComponents/ItemCategorySelect";
import UoMSelect from "../../../../../../customComponents/UoMSelect";
import { GetStckItemLdgrAssociDetails } from "../queries/queries";
import {
  AtsStckItemLdgrAssoicOrderField,
  ItemLdgrAssoicQueryType,
} from "../queries/types";
import useLabels from "../../../../../../customHooks/useLabels";
import { useDebounce } from "../../../../../../customHooks/useDebounce";

interface Props {
  selectedSupplier: selectedSupplierType;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const AssignItems = ({ selectedSupplier, setModalFlag }: Props) => {
  const { Masters_Table } = useAssetTableJson();

  const { dispatch } = useContext(AppContext);
  const { customer_id, company_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const [viewModal, setViewModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [message, setMessage] = useState(emptyMessage);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [items, setItems] = useState<AtsStckItemEdge[]>([]);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [filterData, setFilterData] = useState<filterDataType>({
    ItemGroupId: 0,
    ItemCategoryId: 0,
    UoMId: 0,
  });

  const [GetStockItems, { data, loading, fetchMore }] = useLazyQuery<
    GetItemsResult,
    GetItemsVars
  >(GetItems);

  const [addItemLdgrAssociByLdgr, { loading: AddItemLdgrAssociByLdgrLoading }] =
    useMutation<AddItemLdgrAssociByLdgrResult, AddItemLdgrAssociByLdgrVar>(
      AddItemLdgrAssociByLdgr,
      {
        onError: (err) => {
          setMessage({
            flag: true,
            message: (err as Error).message,
            operation: Operation.NONE,
          });
        },
      }
    );

  const handleCheckboxChange = (id: number) => {
    setSelectedItems(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((itemId) => itemId !== id) // Remove if already selected
          : [...prevSelected, id] // Add if not selected
    );
  };

  const dynamicHeaders: TableHeaderProps[] =
    Masters_Table.Masters.AssociationItems.Assign.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        if (header.field === "id") {
          return (
            <>
              <Checkbox
                value={params.row}
                checked={selectedItems.includes(params.row.itemId)}
                onChange={() => handleCheckboxChange(params.row.itemId)}
                inputProps={{ "aria-label": "controlled" }}
              />
            </>
          );
        }

        return params.value;
      },
    }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.ASSIGN_TO_SUPPLIER
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.ASSIGN_TO_SUPPLIER,
      JSON.stringify(newModel)
    );
  };

  const handleClear = () => {
    setSelectedItems([]);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    setModalFlag(false);
  };

  const HandleSubmit = async () => {
    try {

      if (selectedItems.length) {
        if (customer_id && selectedItems) {
          addItemLdgrAssociByLdgr({
            variables: {
              
              customer_id,
              user_details,
              ldgrId: selectedSupplier.supplierId,
              itemIds: selectedItems,
            },
            refetchQueries: [
              {
                query: GetSuppliers,
                variables: {
                  after: null,
                  customer_id,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsAcLdgrOrderField.CREATED_AT,
                  },
               
                  name: debouncedSearch,
                  input: {
                    query_type: LdgrQueryType.ALL,
                    itemID: 0,
                  },
                },
              },
              {
                query: GetItems,
                variables: {
                  after: null,
                  customerID: customer_id ? customer_id : 0,
                  companyID: 0,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsStckItemOrderField.DESC,
                  },
                 
                  name: EMPTY_STRING,
                  hsnCode: "",
                  input: {
                    query_type: ItemQueryType.ITEMS_NOT_ASSOIC_LDGR,
                    stckCategoryID: 0,
                    stckGroupID: 0,
                    stckManufacturerID: 0,
                    stckUomID: 0,
                    stckSubCategoryID: 0,
                    ldgrID: selectedSupplier.supplierId
                      ? selectedSupplier.supplierId
                      : 0,
                    subsidiaryID: 0,
                  },
                },
              },
              {
                query: GetStckItemLdgrAssociDetails,
                variables: {
                  customer_id,
               
                  input: {
                    queryType: ItemLdgrAssoicQueryType.BY_LDGR_ID,
                    id: selectedSupplier.supplierId,
                    stckCategoryID: 0,
                    stckGroupID: 0,
                    stckManufacturerID: 0,
                    stckUomID: filterData.UoMId ? filterData.UoMId : 0,
                    stckSubCategoryID: 0,
                  },
                  name: debouncedSearch,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsStckItemLdgrAssoicOrderField.LDGR_STATUS,
                  },
                },
              },
            ],
          }).then(({ data }) => {
            if (data && data.AddItemLdgrAssociByLdgr) {
              setMessage({
                flag: true,
                message: "Added successfully",
                operation: Operation.UPDATE,
              });
              setSelectedItems([]);
            }
          });
        }
      } else {
        setMessage({
          flag: true,
          message: "Suppliers is missing",
          operation: Operation.NONE,
        });
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItems.edges;
      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            itemId: node.id,
            desc: node.desc,
            code: node.code,
            item_group: node.groupDetails.groupName,
            item_category: node.categoryDetails.categoryName,
            unit_of_measurement: node.uomDetails.uom,
            ldgr_count: node.ldgr_count,
          }))
        );
      } else {
        setItems(newData);

        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            itemId: node.id,
            desc: node.desc,
            code: node.code,
            item_group: node.groupDetails.groupName,
            item_category: node.categoryDetails.categoryName,
            unit_of_measurement: node.uomDetails.uom,
            ldgr_count: node.ldgr_count,
          }))
        );
      }
      setEndCursor(data.GetItems.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetItems.edges;
              const pageInfo = fetchMoreResult.GetItems.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetItems.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetItems: {
                  edges: [...items, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetItems.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        
        if (customer_id || company_id) {
          GetStockItems({
            variables: {
              after: null,
              customerID: customer_id ? customer_id : 0,
              companyID: company_id ? company_id : 0,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckItemOrderField.DESC,
              },
           
              name: debouncedSearch,
              hsnCode: "",
              input: {
                query_type: ItemQueryType.ITEMS_NOT_ASSOIC_LDGR,
                stckCategoryID: filterData.ItemCategoryId
                  ? filterData.ItemCategoryId
                  : 0,
                stckGroupID: filterData.ItemGroupId
                  ? filterData.ItemGroupId
                  : 0,
                stckManufacturerID: 0,
                stckUomID: filterData.UoMId ? filterData.UoMId : 0,
                stckSubCategoryID: 0,
                ldgrID: selectedSupplier.supplierId
                  ? selectedSupplier.supplierId
                  : 0,
                subsidiaryID: 0,
                isComponent: undefined,
              },
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [customer_id, GetStockItems, debouncedSearch, filterData]);
  const { itemLabel, ledgerLabel } = useLabels();
  return (
    <>
      <div className="assign-supplier">
        <div className="assign-supplier__title">
          <Title>
            Associate {itemLabel} to {ledgerLabel}
          </Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="assign-supplier__header">
          <div className="assign-supplier__header--grid">
            <Label>{ledgerLabel} Name</Label>
            <span>:</span>
            <b>{selectedSupplier.supplierDesc}</b>
          </div>
        </div>
        <Title variant="subtitle1">Assign {itemLabel}</Title>

        <div className="associate-supplier__select row g-0">
          <div className="col-3">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
            />
          </div>
          <div className="col-2">
            <ItemGroupSelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    ItemGroupId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    ItemGroupId: 0,
                  });
                }
              }}
              value={filterData.ItemGroupId}
              onKeyDown={handleMUISelectEvent}
              label={`${itemLabel} Group`}
            />
          </div>
          <div className="col-2">
            <ItemCategorySelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    ItemCategoryId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    ItemCategoryId: 0,
                  });
                }
              }}
              value={filterData.ItemCategoryId}
              label={`${itemLabel} Category`}
              onKeyDown={handleMUISelectEvent}
            />
          </div>
          <div className="col-2">
            <UoMSelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    UoMId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    UoMId: 0,
                  });
                }
              }}
              value={filterData.UoMId}
              label="Unit of Measurement"
              onKeyDown={handleMUISelectEvent}
            />
          </div>
        </div>

        <div className="assign-supplier__tableblock--item">
          {rows.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              onCellClick={(params) => {
                if (params.field === "desc") {
                  dispatch({
                    type: payloadTypes.SET_SUPPLIER_ID,
                    payload: {
                      supplierId: params.row.supplier_id,
                    },
                  });
                  setViewModal(!viewModal);
                }
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>

        <div className="row g-0">
          <div className="col">
            <Button mode="save" onClick={HandleSubmit} />
            <Button mode="clear" onClick={handleClear} />
            <Button mode="cancel" onClick={() => setModalFlag(false)} />
          </div>
          <div className="col-4 flex-end">
            <div className="overall-total-count">
              Selected {itemLabel} <b>{selectedItems.length}</b>
            </div>
          </div>
        </div>
      </div>

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={(!searchData && loading) || AddItemLdgrAssociByLdgrLoading} />
    </>
  );
};

export default AssignItems;
